import React, {Component} from 'react';
import {Layout, Menu, Icon} from 'antd';
import {Link} from 'react-router';
import img from '../../style/imgs/logo.png';
import {roleSuperAdmin, roleAdmin, roleGroupMonitoring, roleStationMonitoring} from '../../constants/defaultValues'
import {APP_NAME} from '../../constants/configValues'
const {Sider} = Layout;

class SiderMenu extends Component {
  state = {
    collapsed: true,
    mode: 'inline',
    openKey: '',
    selectedKey: '',
    firstHide: true
  };
  componentDidMount() {
    this.setMenuOpen(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.onCollapse(nextProps.collapsed);
    this.setMenuOpen(nextProps)
  }
  setMenuOpen = props => {
    const {path} = props;
    this.setState({
      openKey: path.substr(0, path.lastIndexOf('/')),
      selectedKey: path
    });
  };
  onCollapse = (collapsed) => {
    this.setState({
      collapsed,
      firstHide: collapsed,
      mode: collapsed
        ? 'vertical'
        : 'inline'
    });
  };
  menuClick = e => {
    this.setState({selectedKey: e.key});
    const {popoverHide} = this.props;
    popoverHide && popoverHide();
  };
  openMenu = v => {
    this.setState({
      openKey: v[v.length - 1],
      firstHide: false
    })
  };
  render() {
    const {basePath, collapsed, role} = this.props
    const {selectedKey, firstHide, openKey} = this.state
    const presentationPath = `${basePath}/presentation`
    return (<Sider trigger={null} breakpoint="lg" collapsed={collapsed}>
      {
        !this.props.isMobile
          ? <div className="logo">
              <a href="#">
                <img src={img} alt="bg"/>
                <h1>{APP_NAME}</h1>
              </a>
            </div>
          : null
      }
      <Menu onClick={this.menuClick} theme="dark" mode="inline" selectedKeys={[selectedKey]} openKeys={firstHide
          ? null
          : [openKey]} onOpenChange={this.openMenu}>
        {
          !roleSuperAdmin(role)
            ? <Menu.Item key={presentationPath}>
                <Link to={presentationPath}><Icon type="laptop"/>
                  <span className="nav-text">Giám sát</span>
                </Link>
              </Menu.Item>
            : null
        }
        {
          roleGroupMonitoring(role)
            ? <Menu.Item key="/groups">
                <Link to={'/groups'}><Icon type="database"/>
                  <span className="nav-text">Địa bàn</span>
                </Link>
              </Menu.Item>
            : null
        }{
          roleStationMonitoring(role)
            ? <Menu.Item key="/stations">
                <Link to={'/stations'}><Icon type="rocket"/>
                  <span className="nav-text">Trạm</span>
                </Link>
              </Menu.Item>
            : null
        }
        {
          roleAdmin(role)
            ? <Menu.Item key="/users">
                <Link to={'/users'}><Icon type="team"/>
                  <span className="nav-text">Người dùng</span>
                </Link>
              </Menu.Item>
            : null
        }
        {
          roleSuperAdmin(role)
            ? <Menu.Item key="/systems">
                <Link to={'/systems'}><Icon type="code"/>
                  <span className="nav-text">Hệ thống</span>
                </Link>
              </Menu.Item>
            : null
        }
      </Menu>
    </Sider>)
  }
}
export default SiderMenu;/*
        <Menu.Item key="/logs">
          <Link to={'/logs'}><Icon type="hourglass"/>
            <span className="nav-text">Lịch sử</span>
          </Link>
        </Menu.Item>
        {
          roleAdmin(role)
            ? <Menu.Item key="/statistics">
                <Link to={'/statistics'}><Icon type="area-chart"/>
                  <span className="nav-text">Thống kê</span>
                </Link>
              </Menu.Item>
            : null
        }
        */



// WEBPACK FOOTER //
// ./src/components/layouts/SiderMenu.js